import{useTheme as n}from"styled-components";var o=function(n){return Boolean(n.isMobile)},r=function(n){return!n.isMobile},t=function(){var r=n()||{};return o(r)};export{r as isDesktop,o as isMobile,t as useMobile};
